import orderBy from "lodash/orderBy";

import {
  FranchiseType,
  Proposition,
  PropositionAllocation,
  TransmissionType,
} from "@hubcapp/types";
import { isDormantFranchise } from "utils/isDormantFranchise";

const getBrandTitle = (brand: Proposition["brand"]) =>
  brand === "AADS" ? "AA" : "BSM";

const brandSortKeyMap = {
  AA: 1,
  BSM: 2,
};

const franchiseTypeSortKeyMap = {
  [FranchiseType.Full]: 1,
  [FranchiseType.PartnerLite]: 6,
  [FranchiseType.Solo]: 7,
  [FranchiseType.Trainee]: 4,
  [FranchiseType.ThirdParty]: 5,
  [FranchiseType.Dit]: 2,
  [FranchiseType.Motability]: 3,
};

const transmissionSortKeyMap = {
  [TransmissionType.Manual]: 1,
  [TransmissionType.Automatic]: 2,
};

export const sortPropositionAllocationsForTabs = (
  propositionAllocations: PropositionAllocation[],
): PropositionAllocation[] => {
  const sortable = propositionAllocations
    .filter(
      ({ proposition }) =>
        !isDormantFranchise(proposition) && !!proposition.type,
    )
    .map(propositionAllocation => ({
      ...propositionAllocation,
      brandSortKey:
        brandSortKeyMap[getBrandTitle(propositionAllocation.proposition.brand)],
      franchiseTypeSortKey:
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        franchiseTypeSortKeyMap[propositionAllocation.proposition.type!],
      transmissionSortKey: propositionAllocation.proposition.transmission
        ? transmissionSortKeyMap[propositionAllocation.proposition.transmission]
        : undefined,
    }));

  return orderBy(sortable as PropositionAllocation[], [
    "franchiseTypeSortKey",
    "brandSortKey",
    "transmissionSortKey",
  ]);
};
